/**
 * The C1 FX route table (design §5.9).
 *
 * One route: the tolerance-hold queue. It sits beside the rate register
 * (`/enterprise/currency-rates`) rather than inside it because a held rate is *not* a rate — it is a decision waiting for
 * somebody, and burying it in a tab of the rate list is how a fortnight of
 * held observations goes unnoticed.
 *
 * Gated on `fx.hold.read`; accepting or rejecting is checked on the action
 * (`fx.hold.decide`), so somebody who may only watch the queue can open it.
 */

import type { RouteRecordRaw } from 'vue-router'

export const FX_C1_ROUTES: RouteRecordRaw[] = [
  {
    path: '/fx/holds',
    name: 'fx-holds',
    component: () => import('@/modules/fx/HoldsView.vue'),
    meta: { titleKey: 'fx.hold.routeTitle', permission: 'fx.hold.read' },
  },
]
